(function () {
  'use strict';
  var scope = document.querySelector('body.hj-pdp-ux [data-pdp-ux]');
  if (!scope) return;
  function render(current) {
    scope.querySelectorAll('[data-pdp-option-value]').forEach(function (node) {
      var value = (current.options || [])[Number(node.dataset.pdpOptionValue)] || '';
      if (node.textContent !== value) node.textContent = value;
    });
  }
  scope.addEventListener('havjoy:pdp-purchase-state', function (event) { render(event.detail); });

  // Both delivery locations use the existing timeline's configured date/copy.
  var timeline = document.querySelector('.hj__timeline-section');
  var delivery = scope.querySelector('[data-pdp-delivery]');
  if (timeline && delivery) {
    var date = timeline.querySelector('.hj__timeline-step:last-child .hj__timeline-date');
    function syncDelivery() {
      var value = date && date.textContent.trim();
      delivery.hidden = !value || value === '—';
      if (!delivery.hidden) delivery.querySelector('[data-pdp-delivery-date]').textContent = value;
    }
    syncDelivery();
    if (date) new MutationObserver(syncDelivery).observe(date, {childList:true, subtree:true, characterData:true});
  }
  var reviewSection = document.querySelector('[id*="loox_reviews"], #looxReviews');
  if (reviewSection) scope.querySelectorAll('.hj-tee-info__rating').forEach(function (rating) {
    var link = document.createElement('a');
    link.className = rating.className;
    link.href = '#' + reviewSection.id;
    link.setAttribute('aria-label', 'Read customer reviews');
    while (rating.firstChild) link.appendChild(rating.firstChild);
    rating.replaceWith(link);
  });
  if (scope._hjPurchaseState) render(scope._hjPurchaseState);
})();
